import React from 'react';
import { withNamespaces } from 'react-i18next';
import FamilyMembers from 'modules/family/components/family-member-table/family-members';

const FamilyMemberTable = ({ t }) => {
    return (
        <table className="table table-hover table-condensed">
            <thead>
            <tr>
                <th>{t('USER.EMAIL')}</th>
                <th className="text-right">{t('COMMON.ACTIONS')}</th>
            </tr>
            </thead>
            <tbody>
            <FamilyMembers />
            </tbody>
        </table>
    )
};

export default withNamespaces()(FamilyMemberTable);



// WEBPACK FOOTER //
// ./src/modules/family/components/family-member-table/family-member-table.js